import { useAppStateStore } from '../../context/AppStateStore';
import { useCourseData } from './useCourseData';
import { useModuleData } from './useModuleData';
import { useSubmitModule } from './module/useSubmitModule';

export const useSelectedModule = () => {
  const selectedModule = useAppStateStore((state) => state.selectedModule);

  // Get modules and tasks
  const { modules, isLoading: isModulesLoading } = useCourseData();
  const {
    tasks, isLoading: isTasksLoading, isError: isTasksError, error: tasksError,
  } = useModuleData({
    moduleId: selectedModule?.moduleId,
    courseId: selectedModule?.courseId,
  });

  // Find selected module from modules (on app init we don't have the courseId)
  const selectedModuleData = !isModulesLoading && selectedModule?.moduleId && modules
    ? modules.find(
      (m) => m.id === selectedModule.moduleId
            && (selectedModule.courseId ? m.courses.some((c) => c.id === selectedModule.courseId) : true),
    )
    : null;

  const submitModuleMutation = useSubmitModule();

  return {
    module: selectedModuleData,
    tasks: tasks || [],
    isModulesLoading,
    isTasksLoading,
    isTasksError,
    tasksError,
    submitModuleMutation,
  };
};

export default useSelectedModule;
